<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [phoneNumber]="phoneNumber"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage"
  [partners]="partners">
  
  <div class="content-section intro-section">
    <h2 class="section-title">Assurance Multirisque Habitation - MRH</h2>
    <div class="intro-content">
      <p>
        Que vous soyez locataire ou propriétaire d'une maison, d'un seul ou de plusieurs appartements, qu'il s'agisse d'une chambre de bonne ou d'un château de plus de <strong class="highlight-purple">15 pièces</strong>, nous avons les formules qu'il vous faut grâce à nos nombreuses assurances multirisque habitation. De la formule minimale à la formule très Haut de Gamme.
      </p>
      <p>
        Par ailleurs, nous sommes en mesure d'assurer les clients qui ont subi plusieurs sinistres les <strong class="highlight-purple">3 dernières années</strong>.
      </p>
      <p>
        Bien évidemment, il est également possible de rajouter des options supplémentaires très spécifiques comme :
      </p>
      <ul class="features-list">
        <li>Biens en self-stockage,</li>
        <li>Bris matériel informatique,</li>
        <li>Cave à vin,</li>
        <li>Garantie limitée au mobilier,</li>
        <li>Tous risques objets loisirs,</li>
        <li>RC assistante maternelle (pour ceux et celles qui exercent leur activité à la maison),</li>
        <li>RC Chambres d'hôtes,</li>
        <li>RC Chasseur,</li>
        <li>RC équidés, ovins, bovins, ruches, porcins, caprins,</li>
        <li>Table d'hôtes RC,</li>
        <li>Activité professionnelle indépendante à domicile (pour ceux et celles qui exercent leur activité à la maison),</li>
        <li>Assurance pour compte,</li>
        <li>Renonciation à recours.</li>
      </ul>
      <p>
        Il est également possible d'avoir un seul contrat d'assurance pour tous vos appartements/maisons. Ce contrat d'assurance appelé <strong class="text-purple">Flotte Habitation</strong> permet d'assurer jusqu'à <strong class="highlight-purple">500 appartements</strong> sur les principaux risques locatifs (Vol, incendie, dégât des eaux, vandalisme, etc) et peut couvrir une valeur de contenu allant jusqu'à <strong class="highlight-purple">5000€ par appartement</strong> pour cette flotte.
      </p>
      <p>
        Il est très souvent conseillé de souscrire une Assurance Prévoyance GAV (Garantie Accident de la Vie) dont vous trouverez plus d'informations, en plus de l'assurance Multirisque-Habitation (MRH) car <strong class="highlight-purple">50%</strong> des accidents de la vie ont lieu dans l'habitation.
      </p>
      <p>
        Si vous êtes propriétaire, mais que vous n'êtes pas occupant du bien, alors il vous faudra souscrire une assurance <strong class="text-purple">PNO</strong> dite <strong class="text-purple">Assurance Multirisque Immeuble – MRI – PNO</strong>.
      </p>
      <p class="highlight-text">
        Le courtier en Assurance BROKINS est partenaire de nombreux assureurs assurance Habitation, dont un échantillon est affiché ci-dessous : <strong class="text-purple">GENERALI, APRIL, AXA, FMA, NOVELIA SURAVENIR, LIBERTY SPECIALITY, NETVOX, ZEPHIR…</strong>
      </p>
    </div>
  </div>

</app-page-layout>


